module.exports = __webpack_public_path__ + "img/film.68eae794.jpg";